import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

export type TriStateValue = "default" | "off" | "on";

const TRI_STATE_OPTIONS: TriStateValue[] = ["default", "on", "off"];

type OverrideRowProps = {
  rowKey: string;
  dataTestIdPrefix: string;
  effectiveValue: boolean;
  override: boolean | undefined;
  onSelect: (option: TriStateValue) => void;
};

function overrideToTriState(override: boolean | undefined): TriStateValue {
  if (override === undefined) return "default";

  return override ? "on" : "off";
}

export function OverrideRow({
  rowKey,
  dataTestIdPrefix,
  effectiveValue,
  override,
  onSelect,
}: OverrideRowProps) {
  const selected = overrideToTriState(override);
  const isOverridden = override !== undefined;

  return (
    <div className="flex items-center justify-between gap-4 py-3">
      <div className="flex flex-col min-w-0 flex-1">
        <span
          className="body-small-regular font-mono text-text/primary break-all"
          title={rowKey}
        >
          {rowKey}
        </span>
        <span
          className={cnTwMerge(
            "body-small-regular",
            effectiveValue ? "text-brand-default" : "text-text/secondary",
          )}
        >
          {effectiveValue ? "true" : "false"}
          {isOverridden ? " (overridden)" : ""}
        </span>
      </div>
      <div
        className="flex items-center shrink-0 border border-border/primary rounded overflow-hidden"
        role="group"
      >
        {TRI_STATE_OPTIONS.map((option) => (
          <button
            className={cnTwMerge(
              "body-small-regular px-2 py-1 capitalize border-r last:border-r-0 border-border/primary",
              selected === option
                ? "bg-brand-default text-text/on-brand"
                : "bg-background/primary text-text/secondary hover:bg-background/secondary",
            )}
            data-testid={`${dataTestIdPrefix}-${rowKey}-${option}`}
            key={option}
            onClick={() => onSelect(option)}
            type="button"
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}
